(function($){

    var __renderAd = function() {
        var spot = $(this);
        var adcode = spot.data("adcode") || null;

        if (adcode) {
            spot.html(adcode).removeAttr("data-adcode");
        }
    };

    $(document).on("render:mw-paragraph-ads", function(){
        $('div.entry-paragraph-ad > .reactive_ad_spot').each(__renderAd);
        return;
    });

    $(document).on("render:mw-slideshow-ads", function(e, data){
        var slid = data.slideshow_id || null;

        if (slid) {
            var idSelector = 'mobileweb_instream_square_' + slid;
            $('.reactive_ad_spot[id*="' + idSelector + '"]').each(__renderAd);
        }
    });

})(jQuery);
